<template>
    <b-row>
        <b-col xxs="12">
            <div class="mb-2 mt-2">
                <b-button variant="empty" class="pt-0 pl-0 d-inline-block d-md-none" v-b-toggle.displayOptions>
                    pages.display-options
                    <i class="simple-icon-arrow-down align-middle"/>
                </b-button>

                <b-collapse id="displayOptions" class="d-md-block">
                    <div class="d-block d-md-inline-block pt-1">
                        <div class="search-sm d-inline-block float-md-left mr-1 align-top">
                            <b-input placeholder="Search" v-model="search"/>
                        </div>
                    </div>

                    <div class="float-md-right pt-1">
                        <span class="text-muted text-small mr-1 mb-2">{{ from }}-{{ to }} of {{ total }}</span>
                        <b-dropdown id="ddown2" right :text="`${perPageValue}`" variant="outline-dark" class="d-inline-block" size="xs">
                            <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size }}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-collapse>
            </div>
            <div class="separator mb-5" v-show="showBorder"></div>

            <b-card>
                <div class="loading" v-show="dataLoading"></div>
                <div ref="vuetable" v-show="!dataLoading" v-for="(item, index) in data" :key="index">
                    <slot :item="item"></slot>
                </div>
            </b-card>
            <vuetable-pagination-bootstrap class="mt-4" ref="pagination" @vuetable-pagination:change-page="onChangePage"/>
        </b-col>
    </b-row>
</template>

<script>
import axios from 'secure-axios';
import VueTablePaginationBootstrap from './VueTablePaginationBootstrap';

export default {
    name: 'card-data-list',
    props: {
        url: String,

        perPage: {
            type: Number,
            default: 10
        },

        pageSizes: {
            type: Array,
            default: () => [4, 8, 12]
        },

        showBorder: {
            type: Boolean,
            default: false
        }

    },
    data: function () {
        return {
            dataLoading: false,

            search: '',

            from: 0,
            to: 0,

            total: 0,
            lastPage: 0,

            currentPage: 1,
            perPageValue: 10,

            data: []
        };
    },

    beforeMount () {
        this.perPageValue = this.perPage;
    },

    mounted () {
        this.refreshTable();
    },

    methods: {
        makeQueryParams () {
            return {
                page: this.currentPage,
                per_page: this.perPageValue,
                search: this.search
            };
        },

        onPaginationData (paginationData) {
            this.from = paginationData.from;
            this.to = paginationData.to;
            this.total = paginationData.total;
            this.lastPage = paginationData.last_page;
            this.items = paginationData.data;

            this.$refs.pagination.setPaginationData(paginationData);
        },

        updatePerPage () {
            this.perPageValue = this.perPage;
            this.refreshTable();
        },

        refreshTable () {
            const component = this;
            this.showLoadingAnimation();
            axios({
                method: 'get',
                url: this.url,
                params: this.makeQueryParams()
            }).then(function (response) {
                const json = response.data;
                component.onPaginationData(json);
                component.data = json.data;
                component.hideLoadingAnimation();
            });
        },

        showLoadingAnimation () {
            this.dataLoading = true;
        },

        hideLoadingAnimation () {
            this.dataLoading = false;
        },

        onChangePage (page) {
            this.currentPage = page;
            this.refreshTable();
        },

        changePageSize (perPage) {
            this.perPageValue = perPage;
            this.refreshTable();
        }
    },

    watch: {
        perPage: function () {
            this.updatePerPage();
        },

        search: function () {
            this.refreshTable();
        }
    },

    components: {
        'vuetable-pagination-bootstrap': VueTablePaginationBootstrap
    }
};
</script>
